import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class Button extends Component {
    static propTypes = {
        active: PropTypes.bool,
        name: PropTypes.string.isRequired,
        onClickHandler: PropTypes.func,
    }

    static defaultProps = {
        active: false,
        onClickHandler: () => {},
    }

    onClickHandler = () => {
        const { name, onClickHandler } = this.props

        onClickHandler(name)
    }

    render() {
        const { active, name } = this.props

        return <div className={cx(`toolbar-button icon-${name}`, active && 'active')} onClick={this.onClickHandler} />
    }
}
